// FAQAccordion.jsx
import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import home from "../assets/homephoto .webp"
import home1 from "../assets/homephoto1.webp"
import home2 from "../assets/homephoto2.webp"
import home3 from "../assets/homephoto3.webp"
import home4 from "../assets/homephot4.webp"
import home5 from "../assets/homephoto5.webp"
import home6 from "../assets/homephoto6.webp"
import home7 from "../assets/homephoto7.webp"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import AdmissionForm from "./Admisssionsform";
import StudentLife from "./studentlife";
import Events from "./events";

const faqs = [
  {
    question: "Is there a way to apply for admission online?",
    answer:
      "We accept both  online & offline  admissions across all branches. Head over to the your nearest branch website and go to admissions page. Read the instructions and apply online. We are available on call too to clear your doubts/enquiries."
  },
  {
    question: "What syllabus do you follow?",
    answer: "We follow a curriculum that balances academic and co-curricular excellence tailored to various boards  & Integrated syllabus To survive and getting admission  in state, National and International Universities  ( CBSE,ICSE, State, and Cambridge (IGCSE/AS & A Levels))."
  },
  {
    question: "What is the age criteria for admission?",
    answer: "Age criteria differ by class and board guidelines. Kindly refer to the admission section for detailed age requirements."
  },
  {
    question: "When does the admission process begin?",
    answer: "Our admission process generally begins in the September for  every next acadamic year. Please check the school website for exact dates."
  },
  {
    question: "Which curriculum does Rankridge International School in Hyderabad follow?",
    answer:
      "Rankridge follows the CBSE curriculum from Play Group to Grade 12, with integrated IIT-JEE & NEET foundation programs starting from Class 6."
  },
  {
    question: "Where is Rankridge School located near KPHB and Kukatpally, Hyderabad?",
    answer:
      "Rankridge campus is located in KPHB, Kukatpally, Hyderabad, easily accessible from Miyapur, Nizampet, and surrounding localities."
  },
  // {
  //   question: "Is Rankridge the best CBSE school near Kukatpally with IIT & NEET foundation?",
  //   answer:
  //     "Yes. Rankridge is known as one of the best CBSE schools in Hyderabad, offering IIT-JEE and NEET foundation coaching along with regular academics."
  // },
  // {
  //   question: "What makes Rankridge Schools among the top schools in Hyderabad?",
  //   answer:
  //     "With 14+ years of academic excellence, 75,000+ parent trust, small class sizes, personal mentoring, robotics & AI labs, sports, and cultural activities, Rankridge is ranked among the top schools in Hyderabad."
  // },
  // {
  //   question: "What is the minimum age for admission at Rankridge International School?",
  //   answer:
  //     "Admissions begin from Play Group at 2.5 years of age and continue up to Grade 12."
  // },
  // {
  //   question: "Does Rankridge provide safe school bus transport in Hyderabad?",
  //   answer:
  //     "Yes, Rankridge offers safe, GPS-enabled bus facilities covering Kukatpally, KPHB, Miyapur, Nizampet, and other nearby areas."
  // },
  // {
  //   question: "How does Rankridge ensure quality teaching for IIT-JEE and NEET preparation?",
  //   answer:
  //     "We have expert faculty including IITians and doctors, structured foundation programs, doubt-clearing sessions, and personalized mentoring to build a strong competitive edge."
  // },
  // {
  //   question: "Does Rankridge focus only on academics or also extracurricular activities?",
  //   answer:
  //     "Rankridge balances both — we encourage students to explore sports, arts, music, robotics, abacus, leadership clubs, and community service programs."
  // },
  // {
  //   question: "How can parents apply for admission at Rankridge International School, Hyderabad?",
  //   answer:
  //     "Parents can fill out the online admission enquiry form on our website or directly visit the Rankridge campus at KPHB, Kukatpally for assistance."
  // },
  // {
  //   question: "Why do parents choose Rankridge as the best CBSE + IIT/NEET school in Hyderabad?",
  //   answer:
  //     "Parents trust Rankridge for academic excellence, future-ready education, personal mentoring, safe campus, and a balanced approach to both studies and life skills."
  // },
  // {
  //   question: "Is there a way to apply for admission online?",
  //   answer:
  //     "We accept both online & offline admissions across all branches. Head over to your nearest branch website and go to the admissions page. Read the instructions and apply online. We are available on call too to clear your doubts/enquiries."
  // }
];

const images = [
  (home),
  (home1),
  (home2),
  (home3),
  (home4),
  (home5),
  (home6),
  (home7),
  ,
];

export default function Homepage2() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return (
    <div >
     <div className="pb-8 bg-[#20b2aa] me-2 ms-2">
      <StudentLife status={false}  />
</div>

     <section className=" from-blue-50 to-white py-3 px-0 md:px-10 xl:px-20 pt-8 ms-0 me-0">
        
      <Events status={false} />
    </section>
    <section className=" grid grid-cols-1  sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
      {/* Left Testimonial */}
      <div className=" mt-3" >
<AdmissionForm status={false} classData={"w-full ms-0 me-0 grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1"} />
</div>
<div className="text-center sm:ms-0 md:ms-10 lg:ms-10 mt-4">
        <h2 className="text-3xl font-bold mb-2 text-green-900">FAQ's</h2>
        <p className="text-gray-600 m-2">Few commonly asked questions &  also all your doubts are cleared below</p>
   
      <div >
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-teal-400 rounded-md px-6 py-4 transition-all duration-300 bg-white shadow-sm"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center font-semibold text-left text-black text-base md:text-lg"
            >
              <span>{index + 1}. {faq.question}</span>
              {openIndex === index ? <FaMinus /> : <FaPlus />}
            </button>
            {openIndex === index && (
              <div className="mt-3 text-gray-700 text-sm md:text-base">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
         </div>
      {/* Right Form */}
     
    </section>
    </div>
  );
}
